module.exports = __webpack_public_path__ + "static/media/5.a8520a86.jpeg";